module.exports = __webpack_public_path__ + "img/benefit-card-2-mobile.85a4ee40.png";